import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { GALLECTIONS_PER_FETCH, MEDIA_POPUP_GALLECTION_STREAM_GROUP } from '../constants';
import { getGallectionStreamId } from '../helpers';
import { getMode, getCurrentMediaSource } from '../selectors';
import { MediaPopupMode } from '../types';
export function getStreamInitAction(mediaSource, folderId) {
    const streamId = getGallectionStreamId(mediaSource, folderId);
    const streamParams = {
        mediaSource,
        folderId
    };
    return withOffset.actions.initialize({
        streamId,
        groupId: MEDIA_POPUP_GALLECTION_STREAM_GROUP,
        streamParams,
        itemsPerFetch: GALLECTIONS_PER_FETCH,
        hasMore: true
    });
}
function* handleInitGallectionStream(action) {
    const mediaSource = yield select(getCurrentMediaSource);
    if (!mediaSource) {
        return;
    }
    const mode = yield select(getMode);
    const folderId = action.payload.folderId;
    const streamId = getGallectionStreamId(mediaSource, folderId);
    const isStreamInitialized = yield select(selectors.isInitialized, streamId);
    let cacheStreams = true;
    if (mode === MediaPopupMode.MANAGER) {
        cacheStreams = false;
    }
    if (isStreamInitialized && cacheStreams) {
        return;
    }
    yield put(getStreamInitAction(mediaSource, folderId));
    yield put(withOffset.actions.fetch(streamId));
}
export default handleInitGallectionStream;

//# sourceMappingURL=initGallectionStream.js.map